<template>
    <v-card>
      <v-card-title>
        <span class="headline">Condicions d'us</span>
      </v-card-title>
      <v-card-text class="text-modal">
        <p>
          L’accés a la nostra pàgina web per part de l’usuari és gratuït i està condicionat a la lectura prèvia i acceptació íntegra, expressa i sense reserves d’aquestes CONDICIONS GENERALS D’ÚS, vigents en el moment de l’accés, que demanem que llegiu detingudament. Si l’usuari no està d’acord amb aquestes condicions d’ús, s’haurà d’abstenir d’utilitzar aquest portal i d’operar-hi.</p>
          <p> 
L’accés a la nostra pàgina web és gratuït i no necessita subscripció o registre previs. No obstant això, per utilitzar determinats serveis, es pot demanar la subscripció prèvia i l’emplenament de formularis. Aquests casos seran identificats degudament, i s’indicaran en cada moment els procediments que cal seguir per a dur a terme el registre corresponent. Tot el que fa referència a aquests serveis i accessos restringits quedarà subjecte a normativa interna de  Packet Grup S.L., que serà obligat complir per part de tots els usuaris.</p>
          <p> 
L’usuari ha d’accedir a la nostra pàgina web d’acord amb la bona fe, les normes d’ordre públic, aquestes condicions generals d’ús i, si escau, les condicions específiques d’ús que hi siguin aplicables. L’accés al nostre lloc web es fa sota la responsabilitat pròpia i exclusiva de l’usuari, que respondrà en tot cas dels danys i perjudicis que causi a tercers o a nosaltres mateixos.</p>
          <p> 
L’usuari té expressament prohibida la utilització i obtenció dels serveis i continguts oferts en aquesta pàgina web per procediments diferents dels estipulats en aquestes condicions d’ús i, si és el cas, en les condicions particulars que regulin l’adquisició de determinats serveis.</p>
          <p> 
Aquesta pàgina pot contindre enllaços o hiperenllaços que condueixen a altres pàgines web gestionades per tercers aliens a la nostra organització. Així, doncs, Packet Grup no pot garantir el contingut o les informacions que es recullin en les pàgines web esmentades ni la seva veracitat o actualització i, en conseqüència, Packet Grup S.L. queda eximit de qualsevol responsabilitat per danys i perjudicis de tota mena que es puguin derivar de la utilització de pàgines web alienes a la nostra pàgina web.
En qualsevol moment podrem modificar la presentació i configuració del nostre web i els serveis i continguts prestats, tot això unilateralment i sense avís previ. </p>  
      </v-card-text>
          <!--
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">No estoy deacurd</v-btn>
            <v-btn color="green darken-1" text @click="dialog = false">Estoy de acuerdo</v-btn>
          </v-card-actions>
          -->
      </v-card>
</template>

<script>
// import Canvas from './Canvas.vue'

export default {
  name: 'condicionesUso',
  props: {
    msg: String
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

.floating {
  position: absolute;
  left: 50%;
  font-weight: bold;
  font-size: 1em;
  bottom: 0;
}

.widget-content {
  padding:5%;
  padding-bottom: 0;
}

.Intro {
  z-index: 5;
  position: absolute;
  width: 100%;
  padding: 10%;
  left:0;
  bottom: 0;
  padding-bottom: 50px;
}

.v-btn {
  font-family: 'Laro', 'sans serif';
}

.corner-right {
  position: absolute;
  clip-path: circle(400px at 95% -180px);
  padding: 20px;
  height: 50%;
  width: 100%;
  z-index: 1;
  right: 0;
  bottom: 0;
}
.text-modal {
  margin-top: px;
  font-size: 0.74em;
  color: rgb(39, 39, 39) !important;
}
.text-corner {
  margin-right: 55px;
  text-align: left;
  float: right;
  line-height: 2;
  right:-300px;
  padding-top: 40px;
  padding-bottom: 0;
  animation: Text 1s ease-in;
}

.linebase {
  background: purple;
  animation-delay: 1s;
  height: 100px;
  width:1px;
  position: absolute;
  left: 40%;
  top: 50%;
  animation: lines 4s alternate infinite;
  animation-delay: 3s;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.fadeOne-enter-active, .fadeOne-leave-active {
  transition: all .5s ease-out;
}

.fadeOne-enter, .fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active, .fadeTwo-leave-active {
  transition: all .5s ease-out;
}
.fadeTwo-enter, .fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}

.fadethree-enter-active, .fadethree-leave-active {
  transition: all .6s ease-in-out;
}
.fadethree-enter, .fadethree-leave-to {
  transform: translate(100%, 0%);
  opacity: 10%;
  transition: all .6s ease-in-out;
}

.fadefour-enter-active, .fadefour-leave-active {
  transition: all .9s ease-in-out;
}
.fadefour-enter, .fadefour-leave-to {
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  transform: translate(-50%, -100%);
  transform: rotateX(45);
}

.line1, .line2, .line3, .line4 {
	stroke-dasharray:2300;
	stroke-dashoffset:2300;
	animation: dash 5s linear forwards;
}


#spinner {
  -webkit-animation-name: spincube;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-duration: 12s;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 60px 60px 0;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
